const finalAwakening = `

#### 1) Helmet
- Increases all skills by **+1 level** when helmet is **+20 or +21**, **+2 levels** when helmet is **+22 or +23**, and **+3 levels** when helmet is **+24 or +25** (*TP skills not included*).
- Decreases skill cooldown randomly (**5% at +20** up to **30% at +25**).

#### 2) Gloves
- Reduces casting time (**25% at +20**, up to **35% at +25**).
- Increases double attack chance (**5% at +20**, up to **30% at +25**).

#### 3) Boots
- Reduces enemy debuff duration (**25% at +20**, up to **35% at +25**).
- Enhances pet stats (**5% at +20**, up to **30% at +25**).

#### Awakening Process
- Awakening requires a **Final Awakening Stone: Armor**, available at the **Black Marketer NPC**.
- If an item is awakened at **+20**, its awakening remains when further enhanced to **+25**.
- To apply a new awakening, the previous one must be removed using a **Final Sealing Scroll: Armor**, available at **Aladin Center**.

#### Images
![Final Awakening](http://fs1.directupload.net/images/180116/ch5yuwjr.jpg)

![Final Sealing Scroll](http://fs1.directupload.net/images/180116/dck4jgn9.jpg)

![Final Awakening Stone](http://fs1.directupload.net/images/180116/s49238ha.jpg)`;

export default finalAwakening;
